module.exports = __webpack_public_path__ + "static/media/c5.b672fab6.png";